var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRakutenRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.342 1.5c3.75.097 6.808 3.104 6.808 6.838 0 3.104-2.072 5.675-4.933 6.548.987 1.31 2.417 2.716 4.046 3.152.789.242 1.578.194 2.417-.145a8.045 8.045 0 001.677 1.988c.444.485.938.873 1.48 1.26-1.529.922-3.108 1.359-4.687 1.359-.69 0-1.48-.097-2.17-.291-3.997-1.067-6.81-4.802-7.796-6.499v5.723H2.25V1.5h8.092zM7.184 5.429v5.335h2.763c1.43 0 2.516-1.165 2.566-2.62 0-1.357-.938-2.715-2.368-2.715H7.184z",
    fill: "#C61E79"
  })));
}

export default SvgIconRakutenRoom;